import IconButton from '@/components/Buttons/IconButton';
import { theme } from '@de-id/ui-components';
import styled from '@emotion/styled';
import CloseIcon from '@mui/icons-material/Close';

const DialogHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Title = styled.span`
    color: ${theme.colors.secondary.main};
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.4px;
`;

interface Props {
    onClose: () => void;
}

export const DialogHeader = ({ onClose }: Props) => {
    return (
        <DialogHeaderContainer>
            <Title>Post call Webhook </Title>
            <IconButton ariaLabel="close" onClick={onClose}>
                <CloseIcon color="secondary" fontSize="large" />
            </IconButton>
        </DialogHeaderContainer>
    );
};
